import { CfFlowResponse } from '../api/cloudflareFlowApi';
import { cfFailureCopyFor } from '../cfFailureCopy';
import { CF_SETUP_STEPS } from '../components/cfSetupSteps';

export type PreflightFailureRow = { step: string; error: string };

const PREFLIGHT_STEP = CF_SETUP_STEPS.find(({ key }) => key === 'preflight')?.label ?? '';

/** The `[step]` and `[error]` of the PRD's pre-flight row for this flow's failure. */
export function preflightFailureRowFor(flow: CfFlowResponse): PreflightFailureRow {
  const { message } = cfFailureCopyFor(flow.errorDetail?.reason, flow.domain);

  return { step: PREFLIGHT_STEP, error: message };
}
